module.exports = __webpack_public_path__ + "media/src/assets/images/netplay-2e1480e4f41c2550ddec4e0b9dbc3fff.svg";